import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import CardLayout from "../../../components/ReusableComponents/CardLayout";
import DoughnutChart from "../../../components/ReusableComponents/DoughnutChart";
import { ChartCardContent } from "../../dashboard/dashboard.styled";
import { CardWrapper } from "../Lease.styled";
import { toast } from "react-toastify";
import { fetchLeaseData, getChartData } from "../utils";
import ChartlabelALT from "../../../components/ReusableComponents/ChartlabelALT";

const LeaseCharts = ({ profileFilter }) => {
	/* eslint-disable no-unused-vars */
	const [leaseInfo, setLeaseInfo] = useState({ leasee: 0, leasor: 0, sponsored: 0, quick: 0 });
	const [totalLease1, setTotalLease1] = useState(0);
	const [leaseRequests, setLeaseRequests] = useState(null);
	const [leaseData1, setLeaseData1] = useState({
		labels: ["Leasor", "Lease"],
		datasets: [
			{
				label: "user",
				data: [0, 0],
				backgroundColor: ["#00D19F", "#DAE7ED"],
			},
		],
	});
	// Chart 2
	const [totalLease2, setTotalLease2] = useState(0);
	const [leaseData2, setLeaseData2] = useState({
		labels: ["Sponsored", "Quick"],
		datasets: [
			{
				label: "lease",
				data: [0, 0],
				backgroundColor: ["#006770", "#DAE7ED"],
			},
		],
	});

	const [leaseData3, setLeaseData3] = useState({
		labels: ["Vehicles", "Others"],
		datasets: [
			{
				label: "assets",
				data: [0, 0],
				backgroundColor: ["#00D19F", "#DAE7ED"],
			},
		],
	});

	const [leaseData4, setLeaseData4] = useState({
		labels: ["Registered", "Unregistered"],
		datasets: [
			{
				label: "registration",
				data: [0, 0],
				backgroundColor: ["#1D86B2", "#8DBFA1"],
			},
		],
	});

	const [leaseData5, setLeaseData5] = useState({
		labels: ["Insured", "Uninsured"],
		datasets: [
			{
				label: "insurance",
				data: [0, 0],
				backgroundColor: ["#1D86B2", "#8DBFA1"],
			},
		],
	});

	const vehicles = leaseRequests?.filter((req) => req?.productObj.category === "Vehicles");
	const otherAssets = leaseRequests?.filter((req) => req?.productObj.category !== "Vehicles");

	const registeredVehicles = vehicles?.filter((req) => req?.vehicleRegDetails?.registrationNum !== undefined);
	const unRegisteredVehicles = vehicles?.filter(
		(req) => req?.vehicleRegDetails?.registrationNum === undefined
	);

	const insuredAssets = leaseRequests?.filter((req) => req?.insuranceDetails !== undefined);
	const unInsuredAssets = leaseRequests?.filter((req) => req?.insuranceDetails === undefined);

	const getLeaseData = async () => {
		try {
			// eslint-disable-next-line no-unused-vars
			const leaseInfo = await getChartData();
			const leaseData = await fetchLeaseData();

			setLeaseRequests(leaseData);

			if (leaseInfo?.result) {
				let info = leaseInfo.result;
				console.log(info);
				setLeaseInfo({
					leasor: info?.leasor,
					leasee: info?.leasee,
					sponsored: info?.sponsored,
					quick: info?.quick,
				});

				// Chart 1
				let totalLeaseUsers = parseInt(info?.leasor) + parseInt(info?.leasee);
				setTotalLease1(totalLeaseUsers);
				setLeaseData1({
					labels: ["Leasor", "Lease"],
					datasets: [
						{
							label: "user(s)",
							data: [info?.leasor, info?.leasee],
							backgroundColor: ["#00D19F", "#DAE7ED"],
						},
					],
				});
				// Chart 2
				setTotalLease2(parseInt(info?.sponsored) + parseInt(info?.quick));
				setLeaseData2({
					labels: ["Sponsored", "Quick"],
					datasets: [
						{
							label: "lease",
							data: [info?.sponsored, info?.quick],
							backgroundColor: ["#006770", "#DAE7ED"],
						},
					],
				});
			}
		} catch (error) {
			console.error(error);
			toast.error("unable to fetch lease data");
		}
	};

	//chart style props
	const options = {
		plugins: {
			legend: {
				padding: 80,
				display: false,
				position: "bottom",
				align: "right",
				textDirection: "ltr",
				labels: {
					usePointStyle: true,
				},
			},
		},
		responsive: true,
		maintainAspectRatio: true,
		cutout: "80%",
		animation: {
			animateRotate: true,
			animateScale: true,
		},
	};

	const checkForOtherTabs = () => {
		if (profileFilter === "asset_registration" || profileFilter === "insurance") {
			return false;
		} else {
			return true;
		}
	};

	const checkForItemsCard = () => {
		if (profileFilter === "asset_registration" || profileFilter === "insurance") {
			return true;
		} else {
			return false;
		}
	};

	const checkForAssetReg = () => {
		if (profileFilter === "asset_registration") {
			return true;
		} else {
			return false;
		}
	};

	const checkForInsurance = () => {
		if (profileFilter === "insurance") {
			return true;
		} else {
			return false;
		}
	};

	useEffect(() => {
		getLeaseData();
	}, []);

	useEffect(() => {
		if (leaseRequests !== null) {
			setLeaseData3({
				labels: ["Vehicles", "Others"],
				datasets: [
					{
						label: "assets",
						data: [vehicles?.length, otherAssets?.length],
						backgroundColor: ["#006770", "#DAE7ED"],
					},
				],
			});
			setLeaseData4({
				labels: ["Registered", "Unregistered"],
				datasets: [
					{
						label: "registration",
						data: [registeredVehicles?.length, unRegisteredVehicles?.length],
						backgroundColor: ["#1D86B2", "#8DBFA1"],
					},
				],
			});
			setLeaseData5({
				labels: ["Insured", "Uninsured"],
				datasets: [
					{
						label: "insurance",
						data: [insuredAssets?.length, unInsuredAssets?.length],
						backgroundColor: ["#1D86B2", "#8DBFA1"],
					},
				],
			});
		} else {
			return;
		}
	}, [leaseRequests]);

	// console.log(leaseRequests);
	return (
		<CardWrapper>
			{checkForOtherTabs() && (
				<>
					<CardLayout type='Lease'>
						<ChartCardContent firstcolor='#00D19F' secondcolor='#DAE7ED'>
							<DoughnutChart totalAmount={totalLease1} data={leaseData1 && leaseData1} options={options} />
							<ChartlabelALT
								firstColorId={"#00D19F"}
								firstCaption={"Leasor"}
								firstAmount={leaseInfo?.leasor}
								secondColorId={"#DAE7ED"}
								secondCaption={"Leasee"}
								secondAmount={leaseInfo?.leasee}
								totalAmount={totalLease1}
								customLabel={"user(s)"}
							/>
						</ChartCardContent>
					</CardLayout>

					<CardLayout type='Lease Type'>
						<ChartCardContent firstcolor='#00D19F' secondcolor='#DAE7ED'>
							<DoughnutChart totalAmount={totalLease2} data={leaseData2 && leaseData2} options={options} />
							<ChartlabelALT
								firstColorId={"#006770"}
								firstCaption={"Sponsored"}
								firstAmount={leaseInfo?.sponsored}
								secondColorId={"#DAE7ED"}
								secondCaption={"Quick"}
								secondAmount={leaseInfo?.quick}
								totalAmount={totalLease1}
								customLabel={"lease"}
							/>
						</ChartCardContent>
					</CardLayout>
				</>
			)}

			{checkForItemsCard() && (
				<CardLayout type='Items'>
					<ChartCardContent firstcolor='#00D19F' secondcolor='#DAE7ED'>
						<DoughnutChart
							totalAmount={leaseRequests?.length}
							data={leaseData3 && leaseData3}
							options={options}
						/>
						<ChartlabelALT
							firstColorId={"#00D19F"}
							firstCaption='Vehicles'
							firstAmount={vehicles?.length}
							secondColorId={"#DAE7ED"}
							secondCaption='Others'
							secondAmount={otherAssets?.length}
							totalAmount={leaseRequests?.length}
							customLabel={"asset(s)"}
						/>
					</ChartCardContent>
				</CardLayout>
			)}

			{checkForAssetReg() && (
				<CardLayout type='Asset Registration'>
					<ChartCardContent firstcolor='#1D86B2' secondcolor='#8DBFA1'>
						<DoughnutChart totalAmount={vehicles?.length} data={leaseData4 && leaseData4} options={options} />
						<ChartlabelALT
							firstColorId={"#1D86B2"}
							firstCaption='Registered'
							firstAmount={registeredVehicles?.length}
							secondColorId={"#8DBFA1"}
							secondCaption='Not Registered'
							secondAmount={unRegisteredVehicles?.length}
							totalAmount={vehicles?.length}
							customLabel={"asset(s)"}
						/>
					</ChartCardContent>
				</CardLayout>
			)}

			{checkForInsurance() && (
				<CardLayout type='Insurance'>
					<ChartCardContent firstcolor='#1D86B2' secondcolor='#8DBFA1'>
						<DoughnutChart
							totalAmount={leaseRequests?.length}
							data={leaseData5 && leaseData5}
							options={options}
						/>
						<ChartlabelALT
							firstColorId={"#1D86B2"}
							firstCaption='Insured'
							firstAmount={insuredAssets?.length}
							secondColorId={"#8DBFA1"}
							secondCaption='UnInsured'
							secondAmount={unInsuredAssets?.length}
							totalAmount={leaseRequests?.length}
							customLabel={"asset(s)"}
						/>
					</ChartCardContent>
				</CardLayout>
			)}
		</CardWrapper>
	);
};

export default LeaseCharts;

LeaseCharts.propTypes = {
	profileFilter: PropTypes.string,
};
